unit UFakForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UFakList, UFakModel;

type
  TFakForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlFind: TPanel;
    imgFind: TImageControl;
    edtFind: TEdit;
    pnlFakList: TPanel;
    sgFakList: TStringGrid;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure edtFindChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure sgFakListClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FFakList: TFakList;
    FSelectedFak: TFakModel;
    FHideFak: TFakModel;
    procedure HandleError(Sender: TObject; AMsg: string);
    procedure HideFakExecute;
    procedure SgFakListFill(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakList(const Value: TFakList);
    procedure SetSelectedFak(const Value: TFakModel);
    procedure SetHideFak(const Value: TFakModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property FakList: TFakList read FFakList write SetFakList;
    property SelectedFak: TFakModel read FSelectedFak write SetSelectedFak;
    property HideFak: TFakModel read FHideFak write SetHideFak;
  protected procedure LoadDFMValues; override; end;

var
  FakForm: TFakForm;

implementation

uses
  UEssentialHelper, Math;

{$R *.dfm}
{ TFakForm }

procedure TFakForm.btnBackClick(Sender: TObject);
begin
  Self.Close;
end;

procedure TFakForm.edtFindChange(Sender: TObject);
begin
  Self.FakList.GetAll(Self.MainConfig.Uri, edtFind.Text);
end;

procedure TFakForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
end;

procedure TFakForm.HideFakExecute;
var
  i: Integer;
  found: Boolean;
begin
  if Self.HideFak <> nil then
  begin
    i := Self.FakList.Count - 1;
    found := false;
    while not found and (i >= 0) do
      if Self.FakList.Items[i].Nr = Self.HideFak.Nr then
        found := true
      else
        Dec(i);
    if found then
      Self.FakList.Delete(i);
  end;
end;

procedure TFakForm.SetFakList(const Value: TFakList);
begin
  FFakList := Value;
end;

procedure TFakForm.SetHideFak(const Value: TFakModel);
begin
  FHideFak := Value;
end;

procedure TFakForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.FakList.GetAll(Self.MainConfig.Uri, edtFind.Text);
  Self.WebFormResize(Self);
end;

procedure TFakForm.SetSelectedFak(const Value: TFakModel);
begin
  FSelectedFak := Value;
end;

procedure TFakForm.sgFakListClickCell(Sender: TObject; ACol, ARow: Integer);
begin
  if (0 < ARow) and (ARow <= Self.FakList.Count) then
    Self.SelectedFak := Self.FakList.Items[ARow - 1];
  Self.Close;
end;

procedure TFakForm.SgFakListFill(Sender: TObject);
var
  i: Integer;
begin
  if Sender is TFakList then
    Self.FakList := Sender as TFakList;
  Self.HideFakExecute;
  sgFakList.DefaultRowHeight := 32;
  sgFakList.ColCount := 2;
  sgFakList.RowCount := Self.FakList.Count + 1;
  sgFakList.FixedCols := 0;
  sgFakList.FixedRows := 1;
  sgFakList.ColWidths[0] := 5;
  sgFakList.ColWidths[1] := 450;
  sgFakList.Cells[1, 0] := Bold('Projekte');
  for i := 0 to Self.FakList.Count - 1 do
    sgFakList.Cells[1, i + 1] := Self.FakList.Items[i].ToString;
end;

procedure TFakForm.WebFormCreate(Sender: TObject);
begin
  Self.HideFak := nil;
  edtFind.Text := '';
  Self.FakList := TFakList.Create;
  Self.FakList.OnPropertyChanged := Self.SgFakListFill;
  Self.FakList.OnError := Self.HandleError;
end;

procedure TFakForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TFakForm.WebFormResize(Sender: TObject);
var
  d: Integer;
begin
  pnlFind.Top := pnlHeader.Top + pnlHeader.Height;
  pnlFakList.Top := pnlFind.Top + pnlFind.Height;
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Projektliste';
    pnlFind.Top := pnlHeader.Top + pnlHeader.Height;
    pnlFakList.Top := pnlFind.Top + pnlFind.Height;
    pnlFakList.Height := Self.ClientHeight - pnlHeader.Height - pnlFind.Height;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Projektliste';
    pnlFind.Top := pnlHeader.Top + pnlHeader.Height;
    pnlFakList.Top := pnlFind.Top + pnlFind.Height;
    pnlFakList.Height := Self.ClientHeight - pnlHeader.Height - pnlFind.Height -
      pnlFooter.Height;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlFind.Width := Min(535, Self.ClientWidth);
  pnlFakList.Width := pnlFind.Width;
  edtFind.Left := imgFind.Left + imgFind.Width + 8;
  edtFind.Width := pnlFind.ClientWidth - imgFind.Width - 24;
  d := (Self.ClientWidth - pnlFind.Width) div 2;
  if d < 0 then
    d := 0;
  pnlFind.Left := d;
  pnlFakList.Left := pnlFind.Left;
end;

procedure TFakForm.WebFormShow(Sender: TObject);
begin
  Self.SelectedFak := nil;
end;

procedure TFakForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlFind := TPanel.Create(Self);
  imgFind := TImageControl.Create(Self);
  edtFind := TEdit.Create(Self);
  pnlFakList := TPanel.Create(Self);
  sgFakList := TStringGrid.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlFind.BeforeLoadDFMValues;
  imgFind.BeforeLoadDFMValues;
  edtFind.BeforeLoadDFMValues;
  pnlFakList.BeforeLoadDFMValues;
  sgFakList.BeforeLoadDFMValues;
  try
    Name := 'FakForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UFakForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Projektliste';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UFakForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlFind.SetParentComponent(Self);
    pnlFind.Name := 'pnlFind';
    pnlFind.Left := 0;
    pnlFind.Top := 64;
    pnlFind.Width := 640;
    pnlFind.Height := 48;
    pnlFind.Caption := 'pnlFind';
    pnlFind.ChildOrder := 2;
    pnlFind.ShowCaption := False;
    imgFind.SetParentComponent(pnlFind);
    imgFind.Name := 'imgFind';
    imgFind.Left := 4;
    imgFind.Top := 4;
    imgFind.Width := 40;
    imgFind.Height := 40;
    imgFind.HeightPercent := 100.000000000000000000;
    imgFind.WidthPercent := 100.000000000000000000;
    imgFind.URL := 'Images\IconLupe.png';
    edtFind.SetParentComponent(pnlFind);
    edtFind.Name := 'edtFind';
    edtFind.Left := 48;
    edtFind.Top := 13;
    edtFind.Width := 121;
    edtFind.Height := 22;
    edtFind.ChildOrder := 1;
    edtFind.HeightPercent := 100.000000000000000000;
    edtFind.Text := 'edtFind';
    edtFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtFind, Self, 'OnChange', 'edtFindChange');
    pnlFakList.SetParentComponent(Self);
    pnlFakList.Name := 'pnlFakList';
    pnlFakList.Left := 0;
    pnlFakList.Top := 112;
    pnlFakList.Width := 640;
    pnlFakList.Height := 344;
    pnlFakList.Caption := 'pnlFakList';
    pnlFakList.ChildOrder := 3;
    pnlFakList.ShowCaption := False;
    sgFakList.SetParentComponent(pnlFakList);
    sgFakList.Name := 'sgFakList';
    sgFakList.Left := 0;
    sgFakList.Top := 0;
    sgFakList.Width := 640;
    sgFakList.Height := 344;
    sgFakList.Align := alClient;
    sgFakList.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    sgFakList.TabOrder := 0;
    sgFakList.RangeEdit.Max := 100.000000000000000000;
    sgFakList.RangeEdit.Step := 1.000000000000000000;
    sgFakList.HeightPercent := 100.000000000000000000;
    sgFakList.WidthPercent := 100.000000000000000000;
    SetEvent(sgFakList, Self, 'OnClickCell', 'sgFakListClickCell');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlFind.AfterLoadDFMValues;
    imgFind.AfterLoadDFMValues;
    edtFind.AfterLoadDFMValues;
    pnlFakList.AfterLoadDFMValues;
    sgFakList.AfterLoadDFMValues;
  end;
end;

end.
